/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable eqeqeq */
import React, { useEffect, useRef } from 'react';
import { Wrapper } from '../../../components/Wrapper';
import Carousel from 'react-multi-carousel';
import If, { Else } from 'if-else-react';
import PelatihanController, {
  usePelatihanContext,
} from '../../../controller/pelatihan/index';
import PengetahuanController, {
  usePengetahuanContext,
} from '../../../controller/pengetahuan/index';
import PelatihanSayaController, {
  usePelatihanSayaContext,
} from '../../../controller/registered/pelatihan_saya';
import LandingDataController, {
  useLandingDataContext,
} from '../../../controller/public/landing_data';
import { Pelatihan } from '../../../../../entities/Pelatihan';
import Skeleton from 'react-loading-skeleton';
import { ToastContainer } from 'react-toastify';
import HeroCarousel from '../../../components/LandingPage/HeroCarousel';
import SliderBannerPublicContext, {
  useSliderBannerPublicContext,
} from '../../../controller/public/slider_banner';
import EventPintarPublicContext from '../../../controller/public/event_pintar';
import TrainingKnowledge from '../../../components/LandingPage/TrainingKnowledge';
import AboutPintar from '../../../components/LandingPage/AboutPintar';
import Infografis from '../../../components/LandingPage/Infografis';
import { Box, Text, Link, Container, Flex } from '@chakra-ui/react';
import KnowledgeCenter from '../../../components/LandingPage/KnowledgeCenter';
import EventPintar from '../../../components/LandingPage/EventPintar';
import Faq from '../../../components/LandingPage/FrequentlyAsked';
import CardItemPelatihan from '../../../components/global/Card/CardItemPelatihan';
import { PiArrowLeft, PiArrowRight } from 'react-icons/pi';

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 560 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 560, min: 0 },
    items: 1,
  },
};

const TrainingSection: React.FC = () => {
  const { pelatihan, isLoading } = usePelatihanContext().state;
  const carouselRef = useRef<any>(null);

  const handleNext = () => {
    carouselRef.current?.next();
  };

  const handlePrevious = () => {
    carouselRef.current?.previous();
  };

  return (
    <Box bg="white">
      <Container
        maxW="8xl"
        py={{ base: 8, md: 12 }}
        w="full"
        style={{
          background:
            'linear-gradient(107.17deg, #ECFDF5 38.2%, #FFFDE0 113.36%)',
        }}
        borderRadius="xl"
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          w="full"
        >
          <Flex direction="column">
            <Text
              as="h2"
              fontWeight="semibold"
              letterSpacing="tight"
              fontSize={{ base: 'xl', md: '2xl' }}
            >
              Pusat Pembelajaran Mandiri
            </Text>
            <Text>Temukan berbagai pelatihan untuk pengembangan diri</Text>
          </Flex>

          <Flex direction="row" className="gap-2">
            <button
              onClick={handlePrevious}
              className="bg-white shadow-md w-10 h-10 flex items-center justify-center rounded-lg hover:shadow-lg hover:bg-gray-200"
            >
              <PiArrowLeft size={30} className="text-gray-500" />
            </button>
            <button
              onClick={handleNext}
              className="bg-white shadow-md w-10 h-10 flex items-center justify-center rounded-lg hover:shadow-lg hover:bg-gray-200"
            >
              <PiArrowRight size={30} className="text-gray-500" />
            </button>
          </Flex>
        </Box>
        <Box mt={5}>
          <If condition={isLoading}>
            <Skeleton
              count={3}
              style={{ height: '280px', width: '380px', marginRight: '10px' }}
              inline={true}
            />
            <Else />
            <If condition={pelatihan.length > 0}>
              <Carousel
                responsive={responsive}
                ssr={true}
                ref={carouselRef}
                arrows={false}
              >
                {pelatihan.map((v: Pelatihan, key) => (
                  <CardItemPelatihan pelatihan={v} key={v.id} />
                ))}
              </Carousel>
              <Else />
              <Box mx="auto" textAlign="center" my={20}>
                <Text as="h1" fontSize="xl" color="gray.400">
                  Belum Ada Pelatihan Terbaru
                </Text>
              </Box>
            </If>
          </If>
        </Box>

        <Box mt={8}>
          <Link
            href="/pelatihan"
            fontWeight="semibold"
            color="green.700"
            bg="white"
            border="1px solid"
            borderColor="green.700"
            borderRadius="md"
            _hover={{ background: 'green.700', color: 'white' }}
            py="2"
            px="8"
          >
            Lihat Semua
          </Link>
        </Box>
      </Container>
    </Box>
  );
};

const WrapperMain: React.FC = () => {

  const { getMateri } = usePengetahuanContext();

  const { getLandingData } = useLandingDataContext();

  const { getCurrentDateServer } = usePelatihanSayaContext();

  const { fetchData: getSliderBanner } = useSliderBannerPublicContext();

  useEffect(() => {
    getCurrentDateServer().then(() => {
      getMateri(1, '');
      getLandingData();
      getSliderBanner();
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Wrapper>
      {/* Carousel */}
      <HeroCarousel />

      {/* Pelatihan dan Knowledge */}
      <TrainingKnowledge />

      {/* About Pintar */}
      <AboutPintar />

      {/* Training Section */}
      <TrainingSection />

      {/* Knowledge Center */}
      <KnowledgeCenter
        title="Pusat Pembelajaran Terbimbing"
        description="Termukan berbagai pelatihan untuk pengembangan diri"
        type="synchronized"
        navigatePath="/klinik-pengetahuan"
      />

      {/* Sharing Knowledge Center */}
      <KnowledgeCenter
        title="Pusat Berbagi Pengetahuan"
        description="Termukan berbagai pelatihan untuk pengembangan diri"
        type="asynchronized"
        navigatePath="/daftar-pengetahuan"
      />

      {/* event pintar */}
      <EventPintar />

      {/* Infographics */}
      <Infografis />

      {/* Faq */}
      <Faq />
    </Wrapper>
  );
};

const PageMainBeforeLogin: React.FC = () => {
  return (
    <PelatihanController.Provider>
      <PengetahuanController.Provider>
        <PelatihanSayaController.Provider>
          <LandingDataController.Provider>
            <SliderBannerPublicContext.Provider>
              <EventPintarPublicContext.Provider>
                <ToastContainer />
                <WrapperMain />
              </EventPintarPublicContext.Provider>
            </SliderBannerPublicContext.Provider>
          </LandingDataController.Provider>
        </PelatihanSayaController.Provider>
      </PengetahuanController.Provider>
    </PelatihanController.Provider>
  );
};

export default PageMainBeforeLogin;
